export const TIKTOK_PLATFORMS = new Set([
  'tik_tok_messages',
  'tik_tok_comments'
]);

export const TIKTOK_COMMENTS_PLATFORM = 'tik_tok_comments';

export const TIKTOK_BLOCKED_TYPES = new Set(['file', 'audio', 'location', 'video']);

export const isTikTokPlatform = (platform) => TIKTOK_PLATFORMS.has(platform);

export const isTikTokCommentsPlatform = (platform) => platform === TIKTOK_COMMENTS_PLATFORM;
